import React, { useState, useEffect } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../components/admin/common/PageHeading";
import { toast } from "react-toastify";
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { useNavigate, useParams } from "react-router-dom";
import { uiRoutes } from "../../../../routes/ui/uiRoutes";

const EditProject = () => {
  const [response, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSet, setIsSetData] = useState(false);
  const [data, setData] = useState({
    name: "",
    key_points: [""],
    technology: "",
    description: "",
    image_url: "",
    image: null,
  });

  useEffect(() => {
    callAPI("get", "admin/projects/" + id);
  }, []);

  useEffect(() => {
    if (response?.data && !isSet) {
      const fetched = response.data;
      setData({
        ...fetched,
        key_points: Array.isArray(fetched.key_points)
          ? fetched.key_points
          : typeof fetched.key_points === "string"
          ? JSON.parse(fetched.key_points)
          : [""],
        image: null,
      });
      setIsSetData(true);
    }
  }, [response, isSet]);

  const handleKeyPointChange = (index, value) => {
    const updated = [...data.key_points];
    updated[index] = value;
    setData({ ...data, key_points: updated });
  };

  const addKeyPoint = () => {
    setData({ ...data, key_points: [...data.key_points, ""] });
  };

  const removeKeyPoint = (index) => {
    const updated = [...data.key_points];
    updated.splice(index, 1);
    setData({ ...data, key_points: updated });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (key === "key_points") {
        formData.append("key_points", JSON.stringify(data.key_points));
      } else if (key !== "image" && key !== "image_url") {
        formData.append(key, data[key]);
      }
    });

    formData.append("_method", "PUT");

    if (data.image) {
      formData.append("image", data.image);
    }

    callAPI("post", "admin/projects/" + id, formData);
  };

  useEffect(() => {
    if (statusCode === 202) {
      toast.success("Project Updated Successfully!");
      setTimeout(() => {
        navigate(uiRoutes.admin.projects.list);
      }, 1000);
    }
  }, [statusCode, navigate]);

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="container">
          <PageHeading
            title="Edit Project"
            subTitle="Fill out the details to edit Project."
          />
          <form onSubmit={handleSubmit} className="shadow p-4">
            <h6 className="fw-semibold mb-4">Edit Project Form</h6>
            <div className="row">
              {/* Name */}
              <div className="col-md-6 mb-3">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  value={data.name}
                  onChange={(e) =>
                    setData({ ...data, name: e.target.value })
                  }
                  type="text"
                  className="form-control py-2"
                  id="name"
                  placeholder="Enter name"
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.name}
                </span>
              </div>

              {/* Key Points */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Key Points</label>
                {data.key_points.map((point, index) => (
                  <div key={index} className="input-group mb-2">
                    <input
                      type="text"
                      className="form-control"
                      value={point}
                      onChange={(e) =>
                        handleKeyPointChange(index, e.target.value)
                      }
                    />
                    {data.key_points.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => removeKeyPoint(index)}
                      >
                        Remove
                      </button>
                    )}
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={addKeyPoint}
                >
                  + Add Key Point
                </button>
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.key_points}
                </span>
              </div>

              {/* Technology */}
              <div className="col-md-6 mb-3">
                <label htmlFor="technology" className="form-label">
                  Technology
                </label>
                <input
                  value={data.technology}
                  onChange={(e) =>
                    setData({ ...data, technology: e.target.value })
                  }
                  type="text"
                  className="form-control py-2"
                  id="technology"
                  placeholder="Enter Technology"
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.technology}
                </span>
              </div>

              {/* Image */}
              <div className="col-md-6 mb-3">
                <label htmlFor="image" className="form-label">
                  Image
                </label>
                <input
                  type="file"
                  className="form-control py-2"
                  id="image"
                  onChange={(e) =>
                    setData({ ...data, image: e.target.files[0] })
                  }
                />
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.image}
                </span>
                <br />
                {data.image_url && (
                  <img src={data.image_url} height={200} width={200} alt="Preview" />
                )}
              </div>

              {/* Description */}
              <div className="col-12 mb-4">
                <label htmlFor="description" className="form-label">
                  Description
                </label>
                <textarea
                  value={data.description}
                  onChange={(e) =>
                    setData({ ...data, description: e.target.value })
                  }
                  className="form-control py-2"
                  id="description"
                  rows="4"
                  placeholder="Enter Description"
                ></textarea>
                <span className="val-message">
                  {error?.message === "ValidationError" && error?.data?.description}
                </span>
              </div>
            </div>

            <button type="submit" className="btn btn-success">
              Edit Project
            </button>
          </form>
        </div>
      }
    />
  );
};

export default EditProject;
